import { ConditionViewerItem, ConditionViewerTerm } from '@customerio/pluma-components/react';
import type { PageviewNode } from '../../types';
import { getIconForNode } from '../data-source-icon';
import { FilterDetailList, FiltersLeadIn, hasFilters, Times, Within } from '../condition-parts';

type PageviewConditionProps = { node: PageviewNode };

export function PageviewCondition({ node }: PageviewConditionProps) {
  const prefix = node.inverse ? 'Has not' : 'Has';
  return (
    <ConditionViewerItem
      icon={getIconForNode(node)}
      details={hasFilters(node.filters) ? <FilterDetailList filters={node.filters} /> : undefined}
    >
      {prefix} viewed a page
      {node.url != null ? (
        <>
          {' '}
          with the URL <ConditionViewerTerm>{node.url}</ConditionViewerTerm>
        </>
      ) : null}
      <Times times={node.times} />
      <Within within={node.within} />
      <FiltersLeadIn filters={node.filters} filtersOperator={node.filtersOperator} />
    </ConditionViewerItem>
  );
}
